import { Badge } from '@/components/ui/badge';
import type { EquipmentTypeScope } from '@rock/types';
import { assertUnreachable } from '@rock/util';
import type { FC } from 'react';

export const EquipmentTypeScopeBadge: FC<{ scope: EquipmentTypeScope | undefined }> = ({ scope }) => {
    const resolvedScope: EquipmentTypeScope = scope ?? 'normal';

    switch (resolvedScope) {
        case 'normal':
            return <Badge variant="secondary">normal</Badge>;
        case 'system':
            return <Badge className="bg-indigo-600">system</Badge>;
        case 'component':
            return <Badge className="bg-violet-600">component</Badge>;
        case 'supplies':
            return <Badge className="bg-amber-600">supplies</Badge>;
        default:
            assertUnreachable(resolvedScope);
    }
};
